/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/BiscuitsBundleEvents.ts":
/*!*************************************!*\
  !*** ./src/BiscuitsBundleEvents.ts ***!
  \*************************************/
/***/ (() => {

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var BiscuitBundleEvents = /*#__PURE__*/function () {
  function BiscuitBundleEvents() {
    _classCallCheck(this, BiscuitBundleEvents);
    this.biscuitBundleFormReady = "BiscuitsBundleForm:ready";
    this.biscuitBundleProductReady = "BiscuitsBundleProduct:ready";
    this.biscuitBundleStepReady = "BiscuitsBundleStep:ready";
    this.biscuitBundleStepUpdated = "biscuits--step-update";
    this.init = this.init.bind(this);
    this.listenForBundleFormReady = this.listenForBundleFormReady.bind(this);
    this.listenForBundleStepUpdated = this.listenForBundleStepUpdated.bind(this);
  }
  return _createClass(BiscuitBundleEvents, [{
    key: "init",
    value: function init() {
      if (!window.hideBundleCounter) {
        this.listenForBundleFormReady();
        this.listenForBundleStepUpdated();
        document.querySelectorAll("biscuits-bundle-item").forEach(function (step) {
          step.addEventListener("biscuits--product-selection", function (event) {
            console.log("Product Selected", event);
            // Dive into event.detail for the goods
          });
        });
      }
    }
  }, {
    key: "listenForBundleStepUpdated",
    value: function listenForBundleStepUpdated() {
      var _this = this;
      var steps = document.querySelectorAll("biscuits-bundle-step");
      steps.forEach(function (step) {
        var minAmount = step.getAttribute("data-biscuits-maximum-quantity");
        step.addEventListener(_this.biscuitBundleStepUpdated, function (event) {
          var quantityCounter = step.querySelector(".biscuits-bundle-step__counter.biscuits-bundle-step__counter--quantity.biscuit-msg-visible");
          var selectedQuantityEle = quantityCounter.querySelector(".biscuits-bundle-step__quantity");
          var selectedAmount = selectedQuantityEle.textContent;
          if (parseInt(selectedAmount) == parseInt(minAmount)) {
            quantityCounter.classList.add("all-selected");
          } else {
            quantityCounter.classList.remove("all-selected");
          }
          console.log("Step Updated", event);
        });
      });
    }
  }, {
    key: "listenForBundleFormReady",
    value: function listenForBundleFormReady() {
      document.addEventListener(this.biscuitBundleFormReady, function (event) {
        var counters = document.querySelectorAll(".biscuits-bundle-step__counter.biscuits-bundle-step__counter--quantity");
        counters.forEach(function (counter) {
          var counterParent = counter.closest(".biscuits-bundle-step__accordion-content");
          console.log(counterParent);
          var footerMsg = counterParent.querySelector(".biscuits-bundle-step__accordion-footer");
          if (footerMsg) {
            // move the counter to the error message
            counter.classList.add("biscuit-msg-visible");
            footerMsg.appendChild(counter);
          }
        });
      });
    }
  }]);
}();
var biscuitBundleEvents = new BiscuitBundleEvents();
biscuitBundleEvents.init();

/***/ }),

/***/ "./src/Bundle/Bundle.ts":
/*!******************************!*\
  !*** ./src/Bundle/Bundle.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Bundle)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var Bundle = /*#__PURE__*/function (_HTMLElement) {
  function Bundle() {
    var _this;
    _classCallCheck(this, Bundle);
    _this = _callSuper(this, Bundle);
    _this.addToCart = _this.querySelector("#add-bundle-to-cart");
    _this.metaobjectId = _this.dataset.metaobjectId || "";
    _this.productId = _this.dataset.productId || "";
    _this.productUrl = _this.dataset.productUrl || "";
    _this.shop = window.Shopify && window.Shopify.shop ? window.Shopify.shop : "";
    _this.bundleComponents = Array.from(_this.querySelectorAll("bundle-component"));
    _this.loader = _this.querySelector(".bundle-loader-overlay");
    // Track observers so we can clean up
    _this.componentObservers = [];
    return _this;
  }
  _inherits(Bundle, _HTMLElement);
  return _createClass(Bundle, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      // Re-query on connect to catch late slotted/mounted children
      this.bundleComponents = Array.from(this.querySelectorAll("bundle-component"));
      this.addEventListeners();
      this.observeComponentsCompletion();
      this.updateAddToCartState(); // reflect initial state immediately
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      // Clean up observers
      this.componentObservers.forEach(function (obs) {
        return obs.disconnect();
      });
      this.componentObservers = [];
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      if (!this.addToCart) return;
      this.addToCart.addEventListener("click", function (event) {
        return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                event.preventDefault();
                // EARLY RETURN: guard even if someone removed disabled by hand
                if (this.areAllComponentsCompleted()) {
                  _context.n = 1;
                  break;
                }
                // optional: give user feedback; e.g., dispatch event or show toast
                console.warn("Bundle not complete. Please complete all components before adding to cart.");
                return _context.a(2);
              case 1:
                _context.n = 2;
                return this.handleBundleAddToCart();
              case 2:
                return _context.a(2);
            }
          }, _callee, this);
        }));
      });
    }
    /** Observe data-completed attribute on each bundle-component */
  }, {
    key: "observeComponentsCompletion",
    value: function observeComponentsCompletion() {
      var _this3 = this;
      // Safety: disconnect any previous observers
      this.componentObservers.forEach(function (obs) {
        return obs.disconnect();
      });
      this.componentObservers = [];
      var onMutation = function onMutation() {
        _this3.updateAddToCartState();
      };
      this.bundleComponents.forEach(function (comp) {
        var observer = new MutationObserver(function (mutations) {
          var _iterator = _createForOfIteratorHelper(mutations),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var m = _step.value;
              if (m.type === "attributes" && m.attributeName === "data-completed") {
                onMutation();
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        });
        observer.observe(comp, {
          attributes: true,
          attributeFilter: ["data-completed"]
        });
        _this3.componentObservers.push(observer);
      });
    }
    /** True only if every component has data-completed="true" */
  }, {
    key: "areAllComponentsCompleted",
    value: function areAllComponentsCompleted() {
      return this.bundleComponents.length > 0 && this.bundleComponents.every(function (c) {
        return c.getAttribute("data-completed") === "true";
      });
    }
    /** Enable/disable add-to-cart button based on completion */
  }, {
    key: "updateAddToCartState",
    value: function updateAddToCartState() {
      if (!this.addToCart) return;
      var allDone = this.areAllComponentsCompleted();
      this.addToCart.disabled = !allDone;
      // (optional) toggle a class for styling:
      // this.addToCart.classList.toggle("is-disabled", !allDone);
    }
  }, {
    key: "handleBundleAddToCart",
    value: function handleBundleAddToCart() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee2() {
        var components, requestBody, response, data, bundle, variant, _t, _t2, _t3, _t4, _t5, _t6;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              this.setLoading(true);
              // Build the components payload
              components = this.bundleComponents.map(function (component) {
                var bundleItems = Array.from(component.querySelectorAll(".bundle-component-item"));
                var bundleItemsWithQuantity = bundleItems.filter(function (card) {
                  var quantity = parseInt(card.querySelector(".bundle-component-item_quantity").value) || 0;
                  return quantity > 0;
                });
                var componentItems = bundleItemsWithQuantity.map(function (item) {
                  return {
                    variantId: item.dataset.variantId || "",
                    quantity: parseInt(item.querySelector(".bundle-component-item_quantity").value) || 0
                  };
                });
                return {
                  component_items: componentItems
                };
              });
              requestBody = {
                metaobjectId: this.metaobjectId,
                productId: this.productId,
                components: components
              };
              _t = fetch;
              _t2 = "Bearer ";
              _context2.n = 1;
              return this.getJwtToken(this.shop);
            case 1:
              _t3 = _t2.concat.call(_t2, _context2.v);
              _t4 = {
                "Content-Type": "application/json",
                Authorization: _t3
              };
              _t5 = JSON.stringify(requestBody);
              _context2.n = 2;
              return _t("http://bundle-app.edition.dk/api/v1/bundle", {
                method: "POST",
                headers: _t4,
                body: _t5
              });
            case 2:
              response = _context2.v;
              if (response.ok) {
                _context2.n = 3;
                break;
              }
              throw new Error("Failed to add bundle to cart");
            case 3:
              _context2.n = 4;
              return response.json();
            case 4:
              data = _context2.v;
              bundle = data.bundle, variant = data.variant;
              console.log("bundle", JSON.stringify(bundle, null, 2));
              console.log("variant", variant);
              _context2.n = 5;
              return this.pollForVariantCreated(variant);
            case 5:
              _context2.n = 6;
              return this.addVariantToCart(variant);
            case 6:
              this.refreshCart();
              return _context2.a(2, data);
            case 7:
              _context2.p = 7;
              _t6 = _context2.v;
              console.error("Error adding bundle to cart:", _t6);
              this.setLoading(false);
            case 8:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 7]]);
      }));
    }
  }, {
    key: "setLoading",
    value: function setLoading(loading) {
      if (!this.loader) return;
      this.loader.style.display = loading ? "flex" : "none";
    }
  }, {
    key: "refreshCart",
    value: function refreshCart() {
      var _this4 = this;
      document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
        bubbles: true
      }));
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open", {
          bubbles: true
        }));
        _this4.setLoading(false);
      }, 1500);
    }
  }, {
    key: "addVariantToCart",
    value: function addVariantToCart(variant) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee3() {
        var response, _t7, _t8, _t9, _t0, _t1, _t10;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _t7 = fetch;
              _t8 = "Bearer ";
              _context3.n = 1;
              return this.getJwtToken(this.shop);
            case 1:
              _t9 = _t8.concat.call(_t8, _context3.v);
              _t0 = {
                "Content-Type": "application/json",
                Authorization: _t9
              };
              _t1 = JSON.stringify({
                items: [{
                  id: variant,
                  quantity: 1,
                  properties: {
                    _edition_bundle: "true"
                  }
                }]
              });
              _context3.n = 2;
              return _t7("/cart/add.js", {
                method: "POST",
                headers: _t0,
                body: _t1
              });
            case 2:
              response = _context3.v;
              if (response.ok) {
                _context3.n = 3;
                break;
              }
              throw new Error("Failed to add variant to cart");
            case 3:
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t10 = _context3.v;
              console.error("Failed to add variant to cart", _t10);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 4]]);
      }));
    }
  }, {
    key: "pollForVariantCreated",
    value: function pollForVariantCreated(variant) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee4() {
        var response, data, variants, variantMatch, _t11;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (false) // removed by dead control flow
{}
              _context4.p = 1;
              _context4.n = 2;
              return fetch("".concat(this.productUrl, ".json"));
            case 2:
              response = _context4.v;
              if (response.ok) {
                _context4.n = 3;
                break;
              }
              throw new Error("Failed to fetch product data");
            case 3:
              _context4.n = 4;
              return response.json();
            case 4:
              data = _context4.v;
              variants = data.product.variants;
              variantMatch = variants.find(function (v) {
                return String(v.id) === variant;
              });
              if (!variantMatch) {
                _context4.n = 5;
                break;
              }
              return _context4.a(2, true);
            case 5:
              _context4.n = 6;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 1000);
              });
            case 6:
              _context4.n = 8;
              break;
            case 7:
              _context4.p = 7;
              _t11 = _context4.v;
              console.error("Error polling for variant:", _t11);
              // Wait for 1 second before retrying even on error
              _context4.n = 8;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 1000);
              });
            case 8:
              _context4.n = 0;
              break;
            case 9:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 7]]);
      }));
    }
  }, {
    key: "getJwtToken",
    value: function getJwtToken(shop) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee5() {
        var token, _t12;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              token = localStorage.getItem("jwtTokenBundle"); // If no token, or the token is expired, request a new one
              if (!(!token || this.isTokenExpired(token))) {
                _context5.n = 2;
                break;
              }
              _context5.n = 1;
              return this.refreshJwtToken(shop);
            case 1:
              token = _context5.v;
            case 2:
              return _context5.a(2, token);
            case 3:
              _context5.p = 3;
              _t12 = _context5.v;
              console.error("Failed to get JWT token", _t12);
              return _context5.a(2, null);
          }
        }, _callee5, this, [[0, 3]]);
      }));
    }
    // Check if the token is expired
  }, {
    key: "isTokenExpired",
    value: function isTokenExpired(token) {
      var decodedToken = this.decodeJwtToken(token);
      if (decodedToken && decodedToken.exp) {
        var expiry = decodedToken.exp * 1000; // Convert to milliseconds
        return Date.now() > expiry;
      }
      return false;
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "decodeJwtToken",
    value: function decodeJwtToken(token) {
      try {
        var base64Url = token.split(".")[1];
        var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        var jsonPayload = decodeURIComponent(atob(base64).split("").map(function (c) {
          return "%".concat("00".concat(c.charCodeAt(0).toString(16)).slice(-2));
        }).join(""));
        return JSON.parse(jsonPayload);
      } catch (e) {
        console.error("Failed to decode JWT token", e);
        return null;
      }
    }
    // Refresh the JWT token
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "refreshJwtToken",
    value: function refreshJwtToken(shop) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee6() {
        var response, data, jwtToken;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return fetch("http://bundle-app.edition.dk/api/auth", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  shop: shop
                }) // Send shop identifier
              });
            case 1:
              response = _context6.v;
              if (response.ok) {
                _context6.n = 2;
                break;
              }
              throw new Error("Failed to refresh token");
            case 2:
              _context6.n = 3;
              return response.json();
            case 3:
              data = _context6.v;
              jwtToken = data.token;
              localStorage.setItem("jwtTokenBundle", jwtToken);
              return _context6.a(2, jwtToken);
          }
        }, _callee6);
      }));
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/Bundle/BundleComponet.ts":
/*!**************************************!*\
  !*** ./src/Bundle/BundleComponet.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
var BundleComponent = /*#__PURE__*/function (_HTMLElement) {
  function BundleComponent() {
    var _this;
    _classCallCheck(this, BundleComponent);
    var _a, _b;
    _this = _callSuper(this, BundleComponent);
    _this.bundleComponentItems = Array.from(_this.querySelectorAll(".bundle-component-item"));
    _this.selectedQuantity = 0;
    _this.requiredSelectionAmount = parseInt(_this.dataset.requiredSelectionAmount || "0");
    _this.errorMessageElement = _this.querySelector(".error-message");
    _this.itemCounter = _this.querySelector(".bundle-component-item-counter");
    _this.bundle = document.querySelector("edition-bundle");
    _this.bundlePriceOverview = (_a = _this.bundle) === null || _a === void 0 ? void 0 : _a.querySelector("#bundle-price-overview");
    _this.priceStrategy = ((_b = _this.bundle) === null || _b === void 0 ? void 0 : _b.dataset.priceStrategy) || "Fixed";
    _this.layout = _this.dataset.layoutType || "grid";
    // Carousel / dragging
    _this.isDragging = false;
    _this.carouselWrapper = null;
    // momentum + pointer state
    _this.momentumRAF = null;
    _this.dragStartScrollLeft = 0;
    _this.dragStartX = 0;
    _this.hasDragged = false;
    _this.movedPx = 0;
    _this.samples = [];
    // stable handler refs
    _this.onPointerMoveRef = null;
    _this.onPointerUpRef = null;
    // Cleanup
    _this.aborter = null;
    // Track previous values for all inputs
    _this.inputPreviousValues = new Map();
    return _this;
  }
  _inherits(BundleComponent, _HTMLElement);
  return _createClass(BundleComponent, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.resetInputOnMount();
      // Re-query now that we're connected (in case content slotted later)
      this.bundleComponentItems = Array.from(this.querySelectorAll(".bundle-component-item"));
      this.addEventListeners();
      // Initialize previous values for all inputs
      this.bundleComponentItems.forEach(function (item) {
        var quantitySelectorWrapper = item.querySelector(".bundle-component_quantity-selector");
        var input = quantitySelectorWrapper.querySelector("input");
        input.value = "0"; // Ensure input starts at 0
      });
      // Compute initial selected quantity and sync item active states
      this.selectedQuantity = this.bundleComponentItems.reduce(function (sum, item) {
        var input = item.querySelector(".bundle-component_quantity-selector input");
        var v = input ? parseInt(input.value) || 0 : 0;
        if (input) _this2.updateItemActiveState(item, input);
        return sum + v;
      }, 0);
      // Reflect initial UI state
      this.updateCounter(); // also updates completion status
      this.hideError();
      // Initialize blur state
      this.updateBlurState();
      if (this.layout === "carousel") {
        this.initializeCarousel();
      }
      // Cancel momentum on wheel/keyboard to keep control tight
      this.addGlobalInterruptionGuards();
    }
  }, {
    key: "resetInputOnMount",
    value: function resetInputOnMount() {
      var _this3 = this;
      setTimeout(function () {
        // Reset all inputs to 0 on mount
        _this3.bundleComponentItems.forEach(function (item) {
          var quantitySelectorWrapper = item.querySelector(".bundle-component_quantity-selector");
          if (!quantitySelectorWrapper) return;
          var input = quantitySelectorWrapper.querySelector("input");
          if (!input) return;
          input.value = "0";
          _this3.inputPreviousValues.set(input, 0);
          var itemElement = input.closest(".bundle-component-item");
          if (itemElement) itemElement.classList.remove("active", "blurred");
        });
        _this3.selectedQuantity = 0;
      }, 500);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _a;
      // Teardown listeners if element is removed
      (_a = this.aborter) === null || _a === void 0 ? void 0 : _a.abort();
      if (this.momentumRAF !== null) {
        cancelAnimationFrame(this.momentumRAF);
        this.momentumRAF = null;
      }
      document.removeEventListener("pointermove", this.onPointerMoveRef);
      document.removeEventListener("pointerup", this.onPointerUpRef);
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this4 = this;
      this.bundleComponentItems.forEach(function (item) {
        var price = item.dataset.price || "0";
        var quantitySelectorWrapper = item.querySelector(".bundle-component_quantity-selector");
        if (!quantitySelectorWrapper) return;
        var buttons = Array.from(quantitySelectorWrapper.querySelectorAll("button"));
        var input = quantitySelectorWrapper.querySelector("input");
        if (!input) return;
        buttons.forEach(function (button) {
          button.addEventListener("click", function (_event) {
            _event.preventDefault(); // prevent form submission if in a form
            _this4.handleQuantityButtonClick(button, input);
            _this4.updatePrice();
          });
        });
        input.addEventListener("change", function (_event) {
          _this4.handleInputChange(input);
          _this4.updatePrice();
        });
        input.addEventListener("click", function (_event) {
          _event.preventDefault(); // prevent form submission if in a form
        });
      });
    }
  }, {
    key: "handleQuantityButtonClick",
    value: function handleQuantityButtonClick(button, input) {
      var currentValue = parseInt(input.value) || 0;
      var valueToAdd = button.dataset.type === "increment" ? 1 : -1;
      // if currentValue is 0 and valueToAdd is -1, do nothing
      if (currentValue === 0 && valueToAdd === -1) {
        this.updateCounter();
        return;
      }
      // this.selectedQuantity is already equal to requiredSelectionAmount and the user is incrementing, return
      if (this.selectedQuantity === this.requiredSelectionAmount && valueToAdd === 1) {
        this.showError("Du kan kun v\xE6lge ".concat(this.requiredSelectionAmount, " ."));
        this.updateCounter();
        return;
      }
      input.value = (currentValue + valueToAdd).toString();
      this.selectedQuantity += valueToAdd;
      this.inputPreviousValues.set(input, parseInt(input.value));
      // update item active state
      var item = input.closest(".bundle-component-item");
      if (item) this.updateItemActiveState(item, input);
      // Update selection status and hide error if valid
      if (this.selectedQuantity <= this.requiredSelectionAmount) {
        this.hideError();
      }
      this.updateCounter(); // keeps completion in sync
      // Update blur state after quantity change
      this.updateBlurState();
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(input) {
      var newValue = parseInt(input.value) || 0;
      var oldValue = this.inputPreviousValues.get(input) || 0;
      if (newValue < 0) {
        input.value = "0";
        this.selectedQuantity += 0 - oldValue;
        this.inputPreviousValues.set(input, 0);
        this.updateCounter();
        return;
      }
      // Calculate the difference between new and old values
      var difference = newValue - oldValue;
      // Check if the new value would exceed the maximum allowed
      if (this.selectedQuantity + difference > this.requiredSelectionAmount) {
        // Calculate the maximum allowed value for this input
        var maxAllowed = oldValue + (this.requiredSelectionAmount - this.selectedQuantity);
        input.value = maxAllowed.toString();
        this.selectedQuantity = this.requiredSelectionAmount;
        this.showError("Du kan kun v\xE6lge ".concat(this.requiredSelectionAmount, " ."));
      } else {
        // Update the selected quantity with the difference
        this.selectedQuantity += difference;
        this.hideError();
      }
      // Update the stored previous value
      this.inputPreviousValues.set(input, parseInt(input.value));
      // update item active state
      var item = input.closest(".bundle-component-item");
      if (item) this.updateItemActiveState(item, input);
      this.updateCounter(); // keeps completion in sync
      // Update blur state after input change
      this.updateBlurState();
    }
  }, {
    key: "showError",
    value: function showError(message) {
      if (this.errorMessageElement) {
        this.errorMessageElement.textContent = message;
        this.errorMessageElement.classList.add("error-visible");
      }
    }
  }, {
    key: "hideError",
    value: function hideError() {
      if (this.errorMessageElement) {
        this.errorMessageElement.classList.remove("error-visible");
      }
    }
  }, {
    key: "updateCounter",
    value: function updateCounter() {
      var _a;
      if (!this.itemCounter) return;
      var selectedCountElement = this.itemCounter.querySelector(".selected-count");
      if (selectedCountElement) selectedCountElement.textContent = this.selectedQuantity.toString();
      // Toggle error class based on error message visibility
      var hasError = (_a = this.errorMessageElement) === null || _a === void 0 ? void 0 : _a.classList.contains("error-visible");
      hasError ? this.itemCounter.classList.add("with-error") : this.itemCounter.classList.remove("with-error");
      // Toggle completed class when target is met
      if (this.selectedQuantity === this.requiredSelectionAmount) {
        this.itemCounter.classList.add("completed");
        this.itemCounter.classList.remove("with-error"); // Remove error if present
      } else {
        this.itemCounter.classList.remove("completed");
      }
      // Keep completed status in sync
      this.updateCompletionStatus();
    }
  }, {
    key: "updatePrice",
    value: function updatePrice() {
      if (this.priceStrategy !== "Dynamic") {
        return; // If it is not dynamic it means the strategy is Fixed, which means the price is set on mount
      }
      if (!this.bundle || !this.bundlePriceOverview) return;
      // Find all bundle components
      var allBundleComponents = document.querySelectorAll("bundle-component");
      var totalPrice = 0;
      // Calculate total price across all bundle components
      allBundleComponents.forEach(function (component) {
        var items = component.querySelectorAll(".bundle-component-item");
        items.forEach(function (item) {
          var price = parseFloat(item.getAttribute("data-price") || "0");
          var input = item.querySelector("input");
          var quantity = input ? parseInt(input.value) || 0 : 0;
          totalPrice += price * quantity / 100; // prices in cents
        });
      });
      var discountPercentage = this.bundle.dataset.discountPercentage || "0";
      var discountAmount = totalPrice * parseFloat(discountPercentage) / 100;
      var finalPrice = totalPrice - discountAmount;
      var compareAtPriceElement = this.bundlePriceOverview.querySelector("#bundle-compare-at-price");
      var priceElement = this.bundlePriceOverview.querySelector("#bundle-price");
      if (compareAtPriceElement) {
        compareAtPriceElement.textContent = this.formatMoney(totalPrice);
        compareAtPriceElement.dataset.amount = totalPrice.toFixed(2);
      }
      if (priceElement) {
        priceElement.textContent = this.formatMoney(finalPrice);
        priceElement.dataset.amount = finalPrice.toFixed(2);
      }
    }
  }, {
    key: "formatMoney",
    value: function formatMoney(amount) {
      return new Intl.NumberFormat("da-DK", {
        style: "currency",
        currency: "DKK"
      }).format(amount);
    }
  }, {
    key: "updateItemActiveState",
    value: function updateItemActiveState(item, input) {
      var qty = parseInt(input.value) || 0;
      if (qty > 0) {
        item.classList.add("active");
      } else {
        item.classList.remove("active");
      }
    }
    /** Update blur state for all items */
  }, {
    key: "updateBlurState",
    value: function updateBlurState() {
      var isCompleted = this.selectedQuantity === this.requiredSelectionAmount;
      this.bundleComponentItems.forEach(function (item) {
        var input = item.querySelector(".bundle-component_quantity-selector input");
        var qty = input ? parseInt(input.value) || 0 : 0;
        if (isCompleted && qty === 0) {
          item.classList.add("blurred");
        } else {
          item.classList.remove("blurred");
        }
      });
    }
    /* ============================
       Carousel: Pointer Events version
       ============================ */
  }, {
    key: "initializeCarousel",
    value: function initializeCarousel() {
      var _a;
      this.carouselWrapper = this.querySelector(".bundle-components-wrapper-carousel");
      if (!this.carouselWrapper) return;
      // Add CSS class for styling
      this.carouselWrapper.classList.add("carousel-draggable");
      this.carouselWrapper.style.cursor = "grab";
      this.carouselWrapper.style.userSelect = "none";
      // Prevent image/anchor default drag behavior
      this.carouselWrapper.querySelectorAll("img,a").forEach(function (el) {
        el.addEventListener("dragstart", function (e) {
          return e.preventDefault();
        });
      });
      // Clean old listeners if re-init
      (_a = this.aborter) === null || _a === void 0 ? void 0 : _a.abort();
      this.aborter = new AbortController();
      // Pointer Events unify mouse/touch/pen
      this.carouselWrapper.addEventListener("pointerdown", this.startDrag.bind(this), {
        passive: false,
        signal: this.aborter.signal
      });
    }
  }, {
    key: "addGlobalInterruptionGuards",
    value: function addGlobalInterruptionGuards() {
      var _this5 = this;
      // Cancel momentum on wheel or key scroll (space/arrow/PageUp/Down etc.)
      var cancelMomentum = function cancelMomentum() {
        if (_this5.momentumRAF !== null) {
          cancelAnimationFrame(_this5.momentumRAF);
          _this5.momentumRAF = null;
        }
      };
      this.addEventListener("wheel", cancelMomentum, {
        passive: true
      });
      this.addEventListener("keydown", function (e) {
        var keys = [" ", "ArrowLeft", "ArrowRight", "PageUp", "PageDown", "Home", "End"];
        if (keys.includes(e.key)) cancelMomentum();
      });
    }
  }, {
    key: "startDrag",
    value: function startDrag(e) {
      if (!this.carouselWrapper) return;
      var target = e.target;
      if (target && target.closest(BundleComponent.DRAG_EXCLUDE)) return;
      // 🔑 remove pointer capture for testing
      // this.carouselWrapper.setPointerCapture(e.pointerId);
      this.carouselWrapper.classList.add("dragging");
      this.carouselWrapper.style.cursor = "grabbing";
      this.isDragging = true;
      this.hasDragged = false;
      this.movedPx = 0;
      this.dragStartX = e.clientX;
      this.dragStartScrollLeft = this.carouselWrapper.scrollLeft;
      this.samples.length = 0;
      this.samples.push({
        x: e.clientX,
        t: performance.now()
      });
      this.onPointerMoveRef = this.drag.bind(this);
      this.onPointerUpRef = this.endDrag.bind(this);
      document.addEventListener("pointermove", this.onPointerMoveRef, {
        passive: false
      });
      document.addEventListener("pointerup", this.onPointerUpRef);
    }
  }, {
    key: "drag",
    value: function drag(e) {
      if (!this.isDragging || !this.carouselWrapper) return;
      var x = e.clientX;
      var dx = x - this.dragStartX;
      // mark as drag only after threshold
      if (Math.abs(dx) > 5) {
        this.hasDragged = true;
        e.preventDefault();
      }
      var walk = -dx * 1.2;
      this.carouselWrapper.scrollLeft = this.dragStartScrollLeft + walk;
      // record velocity samples
      var now = performance.now();
      this.samples.push({
        x: x,
        t: now
      });
      while (this.samples.length > 0 && now - this.samples[0].t > 120) {
        this.samples.shift();
      }
    }
  }, {
    key: "endDrag",
    value: function endDrag(e) {
      var _a;
      if (!this.isDragging) return;
      this.isDragging = false;
      if (this.carouselWrapper) {
        this.carouselWrapper.classList.remove("dragging");
        this.carouselWrapper.style.cursor = "grab";
      }
      document.removeEventListener("pointermove", this.onPointerMoveRef);
      document.removeEventListener("pointerup", this.onPointerUpRef);
      this.onPointerMoveRef = this.onPointerUpRef = null;
      // calculate total movement
      var dx = e.clientX - this.dragStartX;
      var movedEnough = Math.abs(dx) > 10;
      if (movedEnough) {
        // 👉 only suppress click if a drag happened
        var suppressClick = function suppressClick(clickEvent) {
          if (clickEvent.target.closest("a")) {
            clickEvent.preventDefault();
            clickEvent.stopPropagation();
          }
        };
        (_a = this.carouselWrapper) === null || _a === void 0 ? void 0 : _a.addEventListener("click", suppressClick, {
          capture: true,
          once: true
        });
        // apply fling momentum
        this.applyMomentumFromSamples();
      }
      // else → no drag → let the browser handle <a> normally
    }
  }, {
    key: "applyMomentumFromSamples",
    value: function applyMomentumFromSamples() {
      var _this6 = this;
      if (!this.carouselWrapper || this.samples.length < 2) return;
      var first = this.samples[0];
      var last = this.samples[this.samples.length - 1];
      var dt = Math.max(1, last.t - first.t);
      var vx = (last.x - first.x) / dt;
      // convert to scroll velocity
      var scrollVx = -vx * 30; // tune factor
      var el = this.carouselWrapper;
      var maxScroll = Math.max(0, el.scrollWidth - el.clientWidth);
      var _step = function step(prevTs) {
        return function (ts) {
          var dt = ts - prevTs;
          prevTs = ts;
          el.scrollLeft += scrollVx * dt / 16;
          // bounce at edges
          if (el.scrollLeft < 0 || el.scrollLeft > maxScroll) {
            el.scrollLeft = Math.max(0, Math.min(maxScroll, el.scrollLeft));
            scrollVx *= -0.4;
          }
          scrollVx *= 0.95; // friction
          if (Math.abs(scrollVx) > 0.1) {
            _this6.momentumRAF = requestAnimationFrame(_step(prevTs));
          } else {
            _this6.momentumRAF = null;
          }
        };
      };
      this.momentumRAF = requestAnimationFrame(_step(performance.now()));
    }
  }, {
    key: "updateBundleComponentCompletedStatus",
    value: function updateBundleComponentCompletedStatus(completed) {
      this.setAttribute("data-completed", completed ? "true" : "false");
    }
    /** Central completion checker */
  }, {
    key: "updateCompletionStatus",
    value: function updateCompletionStatus() {
      var completed = this.selectedQuantity === this.requiredSelectionAmount;
      this.updateBundleComponentCompletedStatus(completed);
      // Also update the counter styling directly
      if (this.itemCounter) {
        if (completed) {
          this.itemCounter.classList.add("completed");
          this.itemCounter.classList.remove("with-error");
        } else {
          this.itemCounter.classList.remove("completed");
        }
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Updated DRAG_EXCLUDE to handle anchor tags properly
BundleComponent.DRAG_EXCLUDE = ".bundle-component_quantity-selector, button, input, [data-no-drag]";
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BundleComponent);

/***/ }),

/***/ "./src/CartProgressSection.ts":
/*!************************************!*\
  !*** ./src/CartProgressSection.ts ***!
  \************************************/
/***/ (function() {

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var CartProgressSection = /*#__PURE__*/function (_HTMLElement) {
  function CartProgressSection() {
    var _this;
    _classCallCheck(this, CartProgressSection);
    _this = _callSuper(this, CartProgressSection);
    _this.cartAdd = "on:cart:add";
    _this.lineItemChange = "on:line-item:change";
    _this.cartDrawerRefresh = "dispatch:cart-drawer:refresh";
    _this.cartTotal = Number(_this.dataset.carttotal);
    _this.stepOne = Number(_this.dataset.stepone);
    _this.stepTwo = Number(_this.dataset.steptwo);
    _this.stepThree = Number(_this.dataset.stepthree);
    _this.giftOneDefaultVariantId = _this.dataset.giftonedefault;
    _this.giftTwoDefaultVariantId = _this.dataset.gifttwodefault;
    _this.giftOneQuantity = Number(_this.dataset.giftonequantity);
    _this.giftTwoQuantity = Number(_this.dataset.gifttwoquantity);
    _this.selectedGiftsState = localStorage.getItem("selectedGiftsState") || "{}";
    _this.giftPickerModalTriggers = Array.from(_this.querySelectorAll(".gift-picker-modal-trigger"));
    _this.giftPickerCheckboxes = Array.from(_this.querySelectorAll(".gift-picker-checkbox"));
    _this.giftPickerQuantityWrappers = Array.from(_this.querySelectorAll(".gift-picker-quantity-wrapper"));
    _this.saveChoiceButtons = Array.from(_this.querySelectorAll(".gift-picker-modal-save"));
    _this.attachCartEditListeners = _this.attachCartEditListeners.bind(_this);
    _this.refreshCartDrawer = _this.refreshCartDrawer.bind(_this);
    _this.checkCartProgress = _this.checkCartProgress.bind(_this);
    _this.addProductToCart = _this.addProductToCart.bind(_this);
    _this.removeProductFromCart = _this.removeProductFromCart.bind(_this);
    _this.getGiftItemsInCart = _this.getGiftItemsInCart.bind(_this);
    _this.toggleModal = _this.toggleModal.bind(_this);
    _this.handleCheckboxChange = _this.handleCheckboxChange.bind(_this);
    _this.handleQuantityChange = _this.handleQuantityChange.bind(_this);
    _this.handleSaveChoice = _this.handleSaveChoice.bind(_this);
    return _this;
  }
  _inherits(CartProgressSection, _HTMLElement);
  return _createClass(CartProgressSection, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.attachCartEditListeners();
      this.checkCartProgress();
      this.giftPickerModalTriggers.forEach(function (trigger) {
        trigger.addEventListener("click", function (event) {
          event.preventDefault();
          _this2.toggleModal(trigger);
        });
      });
      this.giftPickerCheckboxes.forEach(function (checkbox) {
        checkbox.addEventListener("change", function (event) {
          _this2.handleCheckboxChange(checkbox);
        });
      });
      this.giftPickerQuantityWrappers.forEach(function (quantityWrapper) {
        var quantityControlButtons = quantityWrapper.querySelectorAll("button");
        var quantityInput = quantityWrapper.querySelector("input");
        quantityControlButtons.forEach(function (button) {
          button.addEventListener("click", function (event) {
            event.preventDefault();
            _this2.handleQuantityChange(button, quantityInput);
          });
        });
        quantityInput.addEventListener("change", function (event) {
          _this2.handleQuantityChange(null, quantityInput);
        });
      });
      this.saveChoiceButtons.forEach(function (button) {
        button.addEventListener("click", function (event) {
          return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  event.preventDefault();
                  this.handleSaveChoice(button);
                case 1:
                  return _context.a(2);
              }
            }, _callee, this);
          }));
        });
      });
    }
  }, {
    key: "attachCartEditListeners",
    value: function attachCartEditListeners() {
      var _this3 = this;
      document.addEventListener(this.cartAdd, function (event) {
        _this3.refreshCartDrawer();
      });
      document.addEventListener(this.lineItemChange, function (event) {
        _this3.refreshCartDrawer();
      });
    }
  }, {
    key: "refreshCartDrawer",
    value: function refreshCartDrawer() {
      this.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
        bubbles: true
      }));
    }
  }, {
    key: "checkCartProgress",
    value: function checkCartProgress() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee2() {
        var giftItemsInCart, giftOnesInCart, giftTwosInCart, selectedGiftsState, giftsToAdd, giftsToRemove, reloadCartDrawer;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.getGiftItemsInCart();
            case 1:
              giftItemsInCart = _context2.v;
              giftOnesInCart = giftItemsInCart.filter(function (item) {
                return item.giftNumber === 1;
              });
              giftTwosInCart = giftItemsInCart.filter(function (item) {
                return item.giftNumber === 2;
              });
              selectedGiftsState = JSON.parse(this.selectedGiftsState);
              giftsToAdd = [];
              giftsToRemove = []; // Check if the cart total is greater than or equal to the stepOne value
              // If it is, check if giftOne already exists in the selectedGiftsState
              if (this.giftOneDefaultVariantId && this.giftOneQuantity) {
                if (this.cartTotal >= this.stepOne) {
                  if (!selectedGiftsState.giftOne) {
                    selectedGiftsState.giftOne = this.giftOneDefaultVariantId;
                    giftsToAdd.push({
                      variantId: this.giftOneDefaultVariantId,
                      quantity: this.giftOneQuantity,
                      giftNumber: 1
                    });
                  }
                }
              }
              // Check if the cart total is greater than or equal to the stepTwo value
              // If it is, check if giftTwo already exists in the selectedGiftsState
              if (this.giftTwoDefaultVariantId && this.giftTwoQuantity) {
                if (this.cartTotal >= this.stepThree) {
                  if (!selectedGiftsState.giftTwo) {
                    selectedGiftsState.giftTwo = this.giftTwoDefaultVariantId;
                    giftsToAdd.push({
                      variantId: this.giftTwoDefaultVariantId,
                      quantity: this.giftTwoQuantity,
                      giftNumber: 2
                    });
                  }
                }
              }
              // Delete giftOne from selectedGiftsState if the cart total is less than the stepOne value
              if (this.cartTotal < this.stepOne) {
                if (selectedGiftsState.giftOne) {
                  delete selectedGiftsState.giftOne;
                  giftOnesInCart.forEach(function (item) {
                    giftsToRemove.push(item.key);
                  });
                }
              }
              // Delete giftTwo from selectedGiftsState if the cart total is less than the stepTwo value
              if (this.cartTotal < this.stepThree) {
                if (selectedGiftsState.giftTwo) {
                  delete selectedGiftsState.giftTwo;
                  giftTwosInCart.forEach(function (item) {
                    giftsToRemove.push(item.key);
                  });
                }
              }
              localStorage.setItem("selectedGiftsState", JSON.stringify(selectedGiftsState));
              reloadCartDrawer = true;
              if (!(giftsToAdd.length > 0)) {
                _context2.n = 2;
                break;
              }
              _context2.n = 2;
              return this.addProductToCart(giftsToAdd, reloadCartDrawer);
            case 2:
              if (!(giftsToRemove.length > 0)) {
                _context2.n = 3;
                break;
              }
              _context2.n = 3;
              return this.removeProductFromCart(giftsToRemove, reloadCartDrawer);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "handleSaveChoice",
    value: function handleSaveChoice(button) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee3() {
        var loader, editText, closestGiftPickerModal, giftNumber, pickedVariants, giftItemsToAdd, giftItems, giftItemsToRemove;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              loader = button.querySelector(".gift-edit-spinner");
              editText = button.querySelector(".gift-edit-text");
              loader.classList.remove("!tw-hidden");
              editText.classList.add("tw-hidden");
              closestGiftPickerModal = button.closest(".gift-picker-modal");
              giftNumber = Number(closestGiftPickerModal.dataset.giftnumber) || 0; // the picked variants can be seen in the qty-input__input elements. If their value is greater than 0. get their data-variantid
              pickedVariants = Array.from(closestGiftPickerModal.querySelectorAll(".qty-input__input")).filter(function (variant) {
                return Number(variant.value) > 0;
              });
              giftItemsToAdd = pickedVariants.map(function (variant) {
                return {
                  variantId: variant.dataset.variantid,
                  quantity: Number(variant.value),
                  giftNumber: giftNumber
                };
              });
              _context3.n = 1;
              return this.getGiftItemsInCart();
            case 1:
              giftItems = _context3.v;
              giftItemsToRemove = giftItems.filter(function (item) {
                return item.giftNumber === giftNumber;
              });
              _context3.n = 2;
              return this.addAndRemoveGiftItems(giftItemsToAdd, giftItemsToRemove, button);
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "handleQuantityChange",
    value: function handleQuantityChange(button, input) {
      var closestGiftPickerModal = input.closest(".gift-picker-modal");
      var saveChoiceButton = closestGiftPickerModal.querySelector(".gift-picker-modal-save");
      var maxQuantity = Number(closestGiftPickerModal.dataset.maxquantity) || 0;
      var currentTotalQuantity = Number(closestGiftPickerModal.dataset.currentquantity) || 0;
      // Parse the current input value as a starting point
      var quantity = Number(input.value) || 0;
      if (button) {
        var name = button.name;
        // Handle button clicks
        if (name === "plus" && quantity < maxQuantity && currentTotalQuantity < maxQuantity) {
          quantity++;
          currentTotalQuantity++;
          closestGiftPickerModal.dataset.currentquantity = currentTotalQuantity.toString();
        } else if (name === "minus" && quantity > 0 && currentTotalQuantity > 0) {
          quantity--;
          currentTotalQuantity--;
          closestGiftPickerModal.dataset.currentquantity = currentTotalQuantity.toString();
        }
        input.value = quantity.toString();
        if (currentTotalQuantity === maxQuantity) {
          saveChoiceButton.classList.remove("disabled-savebtn");
        } else {
          saveChoiceButton.classList.add("disabled-savebtn");
        }
      }
    }
  }, {
    key: "addProductToCart",
    value: function addProductToCart(productsToAdd, reloadCartDrawer) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee4() {
        var items, response, data, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              items = [];
              productsToAdd.forEach(function (product) {
                var giftNumber = product.giftNumber;
                items.push({
                  id: product.variantId,
                  quantity: product.quantity,
                  properties: {
                    _gift: "true",
                    _giftNumber: giftNumber.toString()
                  }
                });
              });
              _context4.n = 1;
              return fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  items: items
                })
              });
            case 1:
              response = _context4.v;
              _context4.n = 2;
              return response.json();
            case 2:
              data = _context4.v;
              if (response.ok) {
                _context4.n = 3;
                break;
              }
              console.error("Error adding product to cart:", data);
              throw new Error("Error adding product to cart");
            case 3:
              if (reloadCartDrawer) {
                this.dispatchEvent(new CustomEvent(this.cartDrawerRefresh, {
                  bubbles: true
                }));
              }
              ;
              window._conv_q = window._conv_q || [];
              window._conv_q.push(["triggerConversion", "100494738"]);
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t = _context4.v;
              console.error(_t);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 4]]);
      }));
    }
  }, {
    key: "removeProductFromCart",
    value: function removeProductFromCart(productsToRemove, reloadCartDrawer) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee5() {
        var updates, response, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              updates = {};
              productsToRemove.forEach(function (product) {
                updates[product] = 0;
              });
              _context5.n = 1;
              return fetch("/cart/update.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  updates: updates
                })
              });
            case 1:
              response = _context5.v;
              if (response.ok) {
                _context5.n = 2;
                break;
              }
              throw new Error("Error removing product from cart");
            case 2:
              if (reloadCartDrawer) {
                this.dispatchEvent(new CustomEvent(this.cartDrawerRefresh, {
                  bubbles: true
                }));
              }
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t2 = _context5.v;
              console.error(_t2);
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 3]]);
      }));
    }
  }, {
    key: "getGiftItemsInCart",
    value: function getGiftItemsInCart() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee6() {
        var response, giftItemsInCart, cart, giftItems, giftOneItems, giftTwoItems, _t3;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return fetch("/cart.js");
            case 1:
              response = _context6.v;
              if (response.ok) {
                _context6.n = 2;
                break;
              }
              throw new Error("Error fetching cart");
            case 2:
              giftItemsInCart = [];
              _context6.n = 3;
              return response.json();
            case 3:
              cart = _context6.v;
              giftItems = cart.items.filter(function (item) {
                return item.properties._gift === "true";
              });
              giftOneItems = giftItems.filter(function (item) {
                return item.properties._giftNumber === "1";
              });
              giftTwoItems = giftItems.filter(function (item) {
                return item.properties._giftNumber === "2";
              }); // create array of gift items in cart, must contain the item.key and giftNumber
              if (giftOneItems.length > 0) {
                giftOneItems.forEach(function (item) {
                  giftItemsInCart.push({
                    key: item.key,
                    giftNumber: 1
                  });
                });
              }
              if (giftTwoItems.length > 0) {
                giftTwoItems.forEach(function (item) {
                  giftItemsInCart.push({
                    key: item.key,
                    giftNumber: 2
                  });
                });
              }
              return _context6.a(2, giftItemsInCart);
            case 4:
              _context6.p = 4;
              _t3 = _context6.v;
              console.error(_t3);
            case 5:
              return _context6.a(2);
          }
        }, _callee6, null, [[0, 4]]);
      }));
    }
  }, {
    key: "toggleModal",
    value: function toggleModal(trigger) {
      var giftCardComponent = trigger.closest(".gift-card-component");
      var modal = giftCardComponent.querySelector(".gift-picker-modal");
      modal.classList.toggle("giftmodal-visible");
    }
  }, {
    key: "handleCheckboxChange",
    value: function handleCheckboxChange(checkbox) {
      var qunatityControlsWrapper = checkbox.closest(".gift-picker-quantity-controls");
      var checkboxWrapper = qunatityControlsWrapper.querySelector(".gift-picker-checkbox-wrapper");
      var quantityWrapper = qunatityControlsWrapper.querySelector(".gift-picker-quantity-wrapper");
      var checked = checkbox.checked;
      if (checked) {
        checkboxWrapper.classList.add("checkbox-selected");
        quantityWrapper.classList.remove("quantity-hidden");
      } else {
        checkboxWrapper.classList.remove("checkbox-selected");
        quantityWrapper.classList.add("quantity-hidden");
      }
    }
  }, {
    key: "addAndRemoveGiftItems",
    value: function addAndRemoveGiftItems(giftItemsToAdd, giftItemsToRemove, button) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee8() {
        var _this4 = this;
        var _t4;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              _context8.p = 0;
              _context8.n = 1;
              return this.removeProductFromCart(giftItemsToRemove.map(function (item) {
                return item.key;
              }), false);
            case 1:
              setTimeout(function () {
                return __awaiter(_this4, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee7() {
                  return _regenerator().w(function (_context7) {
                    while (1) switch (_context7.n) {
                      case 0:
                        _context7.n = 1;
                        return this.addProductToCart(giftItemsToAdd, true);
                      case 1:
                        return _context7.a(2);
                    }
                  }, _callee7, this);
                }));
              }, 1500);
              _context8.n = 3;
              break;
            case 2:
              _context8.p = 2;
              _t4 = _context8.v;
              console.error(_t4);
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this, [[0, 2]]);
      }));
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("cart-progress-section", CartProgressSection);

/***/ }),

/***/ "./src/app.js":
/*!********************!*\
  !*** ./src/app.js ***!
  \********************/
/***/ (() => {



/***/ }),

/***/ "./src/app.scss":
/*!**********************!*\
  !*** ./src/app.scss ***!
  \**********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/app.ts":
/*!********************!*\
  !*** ./src/app.ts ***!
  \********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _consent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./consent */ "./src/consent.ts");
/* harmony import */ var _updateCartDelivery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./updateCartDelivery */ "./src/updateCartDelivery.ts");
/* harmony import */ var _Bundle_BundleComponet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Bundle/BundleComponet */ "./src/Bundle/BundleComponet.ts");
/* harmony import */ var _Bundle_Bundle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Bundle/Bundle */ "./src/Bundle/Bundle.ts");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}




// edition sibling title handling
document.addEventListener("DOMContentLoaded", function () {
  var selectedColor = document.getElementById("edition-selected-color");
  var colors = document.querySelectorAll(".edition-sibling");
  var colorsArray = Array.from(colors);
  if (selectedColor) {
    var selectedColorText = selectedColor.innerText;
    var _iterator = _createForOfIteratorHelper(colorsArray),
      _step;
    try {
      var _loop = function _loop() {
        var color = _step.value;
        color.addEventListener("mouseover", function (event) {
          var img = color.querySelector("img");
          var colorText = color.dataset.title;
          selectedColor.innerText = colorText;
          img.style.scale = "1.1";
        });
        color.addEventListener("mouseout", function (event) {
          var img = color.querySelector("img");
          selectedColor.innerText = selectedColorText;
          if (color.classList.contains("selected-sibling") == false) {
            img.style.scale = "1";
          }
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
});
var editionConsent = new _consent__WEBPACK_IMPORTED_MODULE_0__["default"]();
customElements.define("cart-delivery", _updateCartDelivery__WEBPACK_IMPORTED_MODULE_1__["default"]);
var PurepowerCampaign = /*#__PURE__*/function (_HTMLElement) {
  function PurepowerCampaign() {
    var _this;
    _classCallCheck(this, PurepowerCampaign);
    _this = _callSuper(this, PurepowerCampaign);
    _this.password = "VIP14";
    _this.elementsToRemoveOnRender = ["#product-grid", ".cc-collection-list", "#lasmere", ".cc-collection-banner", ".breadcrumbs", ".countdown-timer"];
    return _this;
  }
  _inherits(PurepowerCampaign, _HTMLElement);
  return _createClass(PurepowerCampaign, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      // If user has entered password remove the blocker and show the content
      var userHasEnteredPasswordThisSession = sessionStorage.getItem("userHasEnteredPassword");
      if (userHasEnteredPasswordThisSession) {
        this.remove();
        return;
      }
      this.removeElements();
      this.initElements();
      this.addEventListeners();
      console.log("token", this.discountToken);
    }
  }, {
    key: "removeElements",
    value: function removeElements() {
      var _this2 = this;
      setTimeout(function () {
        var _iterator2 = _createForOfIteratorHelper(_this2.elementsToRemoveOnRender),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var selector = _step2.value;
            var element = document.querySelector(selector);
            console.log("element", element);
            if (element) {
              element.remove();
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }, 100);
    }
  }, {
    key: "initElements",
    value: function initElements() {
      this.unlockButton = this.querySelector("#unlock-button");
      this.passwordInput = this.querySelector("#password-input");
      this.errorMessage = this.querySelector("#error-message");
      this.successIcon = this.querySelector("#success-icon");
      this.modal = this.querySelector("#unlock-modal");
      this.signupAtag = this.querySelector("#sign-up");
      this.passwordScreen = this.querySelector("#password-screen");
      this.signupScreen = this.querySelector("#signup-screen");
      this.backToPasswordScreen = this.querySelector("#back-to-password-screen");
      this.discountToken = this.dataset.discounttoken;
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this3 = this;
      this.unlockButton.addEventListener("click", function (event) {
        event.preventDefault();
        _this3.handleUnlockButtonClick();
      });
      this.signupAtag.addEventListener("click", function (event) {
        event.preventDefault();
        _this3.handleSignUpAtagClick();
      });
      this.backToPasswordScreen.addEventListener("click", function (event) {
        console.log("back to password screen");
        event.preventDefault();
        _this3.handleBackToPasswordScreenClick();
      });
      this.addKlaviyoFormListeners();
    }
  }, {
    key: "addKlaviyoFormListeners",
    value: function addKlaviyoFormListeners() {
      var _this4 = this;
      setTimeout(function () {
        _this4.klaviyoForm = _this4.querySelector("form.klaviyo-form");
        if (_this4.klaviyoForm) {
          _this4.klaviyoForm.addEventListener("submit", function (event) {
            setTimeout(function () {
              _this4.passwordInput.value = _this4.password;
              _this4.handleUnlockButtonClick();
            }, 1500);
          });
          var submitButton = _this4.klaviyoForm.querySelector("button[type='button']");
          console.log("submitButton", submitButton);
          if (submitButton) {
            submitButton.addEventListener("click", function (event) {
              setTimeout(function () {
                _this4.passwordInput.value = _this4.password;
                _this4.handleUnlockButtonClick();
              }, 1500);
            });
          }
        }
      }, 2000);
    }
  }, {
    key: "handleBackToPasswordScreenClick",
    value: function handleBackToPasswordScreenClick() {
      this.togglePasswordScreen();
      this.toggleSignupScreen();
    }
  }, {
    key: "handleSignUpAtagClick",
    value: function handleSignUpAtagClick() {
      this.togglePasswordScreen();
      this.toggleSignupScreen();
    }
  }, {
    key: "togglePasswordScreen",
    value: function togglePasswordScreen() {
      this.passwordScreen.classList.toggle("tw-hidden");
      this.passwordScreen.classList.toggle("tw-flex");
    }
  }, {
    key: "toggleSignupScreen",
    value: function toggleSignupScreen() {
      this.signupScreen.classList.toggle("tw-hidden");
      this.signupScreen.classList.toggle("tw-flex");
    }
  }, {
    key: "handleUnlockButtonClick",
    value: function handleUnlockButtonClick() {
      var password = this.passwordInput.value;
      if (password === this.password) {
        // Show unlock animation and set the cookie and redirect
        this.handleUnlock();
      } else {
        this.handleError();
      }
    }
  }, {
    key: "handleError",
    value: function handleError() {
      var _this5 = this;
      this.errorMessage.classList.remove("tw-hidden");
      this.errorMessage.classList.add("alert-animate");
      setTimeout(function () {
        _this5.errorMessage.classList.remove("alert-animate");
        _this5.errorMessage.classList.add("tw-hidden");
      }, 3000);
    }
  }, {
    key: "handleUnlock",
    value: function handleUnlock() {
      var _this6 = this;
      this.successIcon.classList.remove("tw-hidden");
      this.successIcon.classList.add("tw-flex");
      setTimeout(function () {
        _this6.modal.classList.add("unlock-success");
        setTimeout(function () {
          sessionStorage.setItem("userHasEnteredPassword", "true");
          // Redirect to the currentUrl with the discount added as a url parm
          var currentUrl = window.location.href;
          var url = new URL(currentUrl);
          url.searchParams.set("token", _this6.discountToken);
          // Redirect to the new URL
          window.location.href = url.toString();
        }, 600);
      }, 1200);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("purepower-campaign", PurepowerCampaign);
var DiscountNinja = /*#__PURE__*/function () {
  function DiscountNinja() {
    _classCallCheck(this, DiscountNinja);
    this.init = this.init.bind(this);
  }
  return _createClass(DiscountNinja, [{
    key: "init",
    value: function init() {
      this.listenForDiscountNinjaEvents();
    }
  }, {
    key: "listenForDiscountNinjaEvents",
    value: function listenForDiscountNinjaEvents() {
      document.addEventListener("la:dn:cart:updated", function (event) {
        setTimeout(function () {
          // log with gren color
          console.log("%c Edition - DiscountNinja Cart Update available- ", "color: green;");
          document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
            bubbles: true
          }));
        }, 1500);
      });
    }
  }]);
}();
var discountNinja = new DiscountNinja();
discountNinja.init();
customElements.define("bundle-component", _Bundle_BundleComponet__WEBPACK_IMPORTED_MODULE_2__["default"]);
customElements.define("edition-bundle", _Bundle_Bundle__WEBPACK_IMPORTED_MODULE_3__["default"]);

/***/ }),

/***/ "./src/consent.ts":
/*!************************!*\
  !*** ./src/consent.ts ***!
  \************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionConsent)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var EditionConsent = /*#__PURE__*/function () {
  function EditionConsent() {
    var _this = this;
    _classCallCheck(this, EditionConsent);
    // declare dataLayer
    this.dataLayer = window.dataLayer || [];
    // Event listener for visitor consent collection - built in Shopify event for visitor consent
    document.addEventListener("visitorConsentCollected", function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
        var state, visitorConsent;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              state = "update";
              _context.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context.v;
              console.log(visitorConsent, state);
              this.consentSettings(visitorConsent, state);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
    });
    this.updateConsent();
  }
  // methods
  // method to push data to the dataLayer
  // method to update consent settings based on visitorconsent and state
  // method to the fire gtag method with the consent settings from updateConsent method
  return _createClass(EditionConsent, [{
    key: "gtag",
    value: function gtag() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      this.dataLayer.push(arguments);
    }
  }, {
    key: "updateConsent",
    value: function updateConsent() {
      var state = "update";
      if (!window.Shopify.customerPrivacy) return;
      var visitorConsent = window.Shopify.customerPrivacy.currentVisitorConsent();
      console.log(visitorConsent, state);
      this.consentSettings(visitorConsent, state);
    }
  }, {
    key: "consentSettings",
    value: function consentSettings(visitorConsent, state) {
      var consent = {
        functionality_storage: visitorConsent.preferences === "yes" ? "granted" : "granted",
        analytics_storage: visitorConsent.analytics === "yes" ? "granted" : "denied",
        personalization_storage: visitorConsent.analytics === "yes" ? "granted" : "denied",
        ad_storage: visitorConsent.marketing === "yes" ? "granted" : "denied",
        ad_user_data: visitorConsent.marketing === "yes" ? "granted" : "denied",
        ad_personalization: visitorConsent.marketing === "yes" ? "granted" : "denied",
        wait_for_update: 500
      };
      this.gtag("consent", state, consent);
      // set local Storage for consent settings for further use on other pages or after page refresh
      localStorage.setItem("consentSettings", JSON.stringify(consent));
    }
  }]);
}();


/***/ }),

/***/ "./src/formatmoney.ts":
/*!****************************!*\
  !*** ./src/formatmoney.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_0__);

function formatMoney(amount) {
  var locale = Shopify.locale;
  var currency = Shopify.currency.active;
  return amount.toLocaleString(locale, {
    style: "currency",
    currency: currency
  });
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (formatMoney);

/***/ }),

/***/ "./src/freeGift.ts":
/*!*************************!*\
  !*** ./src/freeGift.ts ***!
  \*************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

function getCartData() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
    var _a, response, data, totalPrice, lineItems, giftInCart, giftItemKey, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return fetch("/cart.json");
        case 1:
          response = _context.v;
          _context.n = 2;
          return response.json();
        case 2:
          data = _context.v;
          totalPrice = data.total_price; // check if the cart already has the gift. Done by checking the properties of the line items
          lineItems = data.items;
          console.log("lineItems", lineItems);
          giftInCart = lineItems.some(function (item) {
            if (item.variant_id === window.freeGift) {
              return true;
            }
          });
          if (giftInCart) {
            totalPrice = totalPrice - lineItems.find(function (item) {
              return item.variant_id === window.freeGift;
            }).line_price;
          }
          // find the gift in the line items
          giftItemKey = (_a = lineItems.find(function (item) {
            return item.variant_id === window.freeGift;
          })) === null || _a === void 0 ? void 0 : _a.key;
          return _context.a(2, {
            totalPrice: totalPrice,
            giftInCart: giftInCart,
            giftItemKey: giftItemKey
          });
        case 3:
          _context.p = 3;
          _t = _context.v;
          console.error(_t);
        case 4:
          return _context.a(2);
      }
    }, _callee, null, [[0, 3]]);
  }));
}
function updateCart(updates) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee2() {
    var response, data, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.p = 0;
          _context2.n = 1;
          return fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              updates: updates
            })
          });
        case 1:
          response = _context2.v;
          _context2.n = 2;
          return response.json();
        case 2:
          data = _context2.v;
          _context2.n = 4;
          break;
        case 3:
          _context2.p = 3;
          _t2 = _context2.v;
          console.error(_t2);
        case 4:
          return _context2.a(2);
      }
    }, _callee2, null, [[0, 3]]);
  }));
}
function checkGift() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee3() {
    var cartData, freeGiftThreshold;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return getCartData();
        case 1:
          cartData = _context3.v;
          freeGiftThreshold = window.freeGiftThreshold;
          if (!(cartData.totalPrice >= freeGiftThreshold)) {
            _context3.n = 2;
            break;
          }
          updateCart(_defineProperty({}, window.freeGift, 1));
          _context3.n = 4;
          break;
        case 2:
          if (!(cartData.totalPrice < freeGiftThreshold)) {
            _context3.n = 3;
            break;
          }
          updateCart(_defineProperty({}, cartData.giftItemKey, 0));
          setTimeout(function () {
            document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
              bubbles: true
            }));
          }, 500);
          _context3.n = 4;
          break;
        case 3:
          return _context3.a(2);
        case 4:
          return _context3.a(2);
      }
    }, _callee3);
  }));
}
// remove the gift on dom load
document.addEventListener("DOMContentLoaded", function () {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee4() {
    var cartData;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          if (!(window.cartProgressSectionEnabled === false)) {
            _context4.n = 2;
            break;
          }
          _context4.n = 1;
          return getCartData();
        case 1:
          cartData = _context4.v;
          if (cartData.giftInCart) {
            updateCart(_defineProperty({}, cartData.giftItemKey, 0));
            setTimeout(function () {
              document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
                bubbles: true
              }));
            }, 1000);
          }
        case 2:
          return _context4.a(2);
      }
    }, _callee4);
  }));
});
var editionForm = /*#__PURE__*/function (_HTMLElement) {
  function editionForm() {
    var _this;
    _classCallCheck(this, editionForm);
    _this = _callSuper(this, editionForm);
    _this.init = _this.init.bind(_this);
    _this.init();
    return _this;
  }
  _inherits(editionForm, _HTMLElement);
  return _createClass(editionForm, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      var checkOutBtn = this.querySelector("button[type='submit']");
      checkOutBtn.addEventListener("click", function (event) {
        return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee5() {
          var cartTerms;
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                event.preventDefault();
                cartTerms = document.getElementById("cart-terms");
                if (!(cartTerms.checked && window.cartProgressSectionEnabled === false)) {
                  _context5.n = 2;
                  break;
                }
                _context5.n = 1;
                return checkGift();
              case 1:
                setTimeout(function () {
                  window.location.href = "/checkout";
                }, 1200);
                _context5.n = 3;
                break;
              case 2:
                window.location.href = "/checkout";
              case 3:
                return _context5.a(2);
            }
          }, _callee5);
        }));
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("edition-form", editionForm);

/***/ }),

/***/ "./src/freeshippingbar.ts":
/*!********************************!*\
  !*** ./src/freeshippingbar.ts ***!
  \********************************/
/***/ (function() {

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var freeShippingBar = /*#__PURE__*/function (_HTMLElement) {
  function freeShippingBar() {
    var _this;
    _classCallCheck(this, freeShippingBar);
    _this = _callSuper(this, freeShippingBar);
    _this.freeShippingThreshold = window.freeShippingThreshold;
    return _this;
  }
  _inherits(freeShippingBar, _HTMLElement);
  return _createClass(freeShippingBar, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      setTimeout(function () {
        var threshold = _this2.freeShippingThreshold / 100;
        getCart(threshold);
        // listen for changes to the cartItems
        var cartItems = document.querySelector("#cart-items");
        var cartItemsObserver = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            console.log("cart items changed");
            getCart(threshold);
          });
        });
        console.log(cartItems);
        cartItemsObserver.observe(cartItems, {
          attributes: true,
          childList: true,
          characterData: true
        });
      }, 500);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("edition-free-shipping-bar", freeShippingBar);
// get the cart
function getCart(threshold) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
    var response, data, customBarEle, cartTotal, percent, dots, _i, _dots, dot, step, stepNum, bar, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return fetch("/cart.js", {
            method: "GET",
            headers: {
              "Content-Type": "application/json"
            }
          });
        case 1:
          response = _context.v;
          if (!response.ok) {
            _context.n = 3;
            break;
          }
          _context.n = 2;
          return response.json();
        case 2:
          data = _context.v;
          customBarEle = document.querySelector("edition-free-shipping-bar");
          cartTotal = data.total_price;
          cartTotal = cartTotal / 100;
          if (cartTotal === 0) {
            customBarEle.style.display = "none";
          } else {
            customBarEle.style.display = "block";
          }
          // cacluate how much percent is filled
          percent = cartTotal / threshold;
          percent = percent * 100;
          percent = Math.round(percent);
          // get all shipping dots
          dots = Array.from(customBarEle.querySelectorAll(".shipping-dot"));
          for (_i = 0, _dots = dots; _i < _dots.length; _i++) {
            dot = _dots[_i];
            step = dot.dataset.id;
            stepNum = Number(step);
            stepNum <= cartTotal ? dot.classList.add("tw-bg-black") : dot.classList.remove("tw-bg-black");
          }
          // get the bar and fill it
          bar = customBarEle.querySelector("#amount_filled");
          bar.style.width = percent + "%";
          _context.n = 3;
          break;
        case 3:
          _context.n = 5;
          break;
        case 4:
          _context.p = 4;
          _t = _context.v;
          console.error("Error:", _t);
        case 5:
          return _context.a(2);
      }
    }, _callee, null, [[0, 4]]);
  }));
}

/***/ }),

/***/ "./src/klaviyoAddedToCart.ts":
/*!***********************************!*\
  !*** ./src/klaviyoAddedToCart.ts ***!
  \***********************************/
/***/ (() => {

/*
import "./types";

document.addEventListener("DOMContentLoaded", () => {
  var _learnq = window._learnq || [];

  let item: Item = {} as Item;

  (function (ns, fetch) {
    ns.fetch = async function () {
      const response = await fetch.apply(this, arguments);

      if (`${window.location.origin}/cart/add.js`.includes(response.url)) {
        try {
          const clonedResponse = response.clone();
          const data = await clonedResponse.json();
          console.log("data", data);
          item = { ...data };
          if (klAjax) {
            _learnq.push(["track", "Added to Cart", item]);
          }
        } catch (error) {
          console.error("Error parsing JSON:", error);
        }
      }
      return response;
    };
  })(window, window.fetch);

  let klAjax = true;
});
*/

/***/ }),

/***/ "./src/mixpdp.ts":
/*!***********************!*\
  !*** ./src/mixpdp.ts ***!
  \***********************/
/***/ (() => {

function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
setTimeout(function () {
  var radioBtns = Array.from(document.querySelectorAll('.edition-radio'));
  if (radioBtns.length >= 1) {
    var _iterator = _createForOfIteratorHelper(radioBtns),
      _step;
    try {
      var _loop = function _loop() {
        var radioBtn = _step.value;
        radioBtn.addEventListener('change', function () {
          var value = radioBtn.value;
          var quantityPicker = document.querySelector('form quantity-input .qty-input__input.input');
          // set the value of the quantity picker to our value
          quantityPicker.value = value;
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
}, 500);

/***/ }),

/***/ "./src/modalopener.ts":
/*!****************************!*\
  !*** ./src/modalopener.ts ***!
  \****************************/
/***/ (() => {

setTimeout(function () {
  var modalOpeners = Array.from(document.querySelectorAll('button[data-modalid'));
  var _loop = function _loop() {
    var opener = _modalOpeners[_i];
    opener.addEventListener('click', function (event) {
      var modalId = opener.dataset.modalid;
      var modal = document.querySelector("div[data-modalid=\"".concat(modalId, "\"]"));
      modal.classList.toggle('tw-hidden');
      setTimeout(function () {
        modal.classList.toggle('tw-opacity-0');
      }, 300);
    });
  };
  for (var _i = 0, _modalOpeners = modalOpeners; _i < _modalOpeners.length; _i++) {
    _loop();
  }
  var modalClosers = Array.from(document.querySelectorAll('.edition-modal-close[data-modalid]'));
  var _loop2 = function _loop2() {
    var closer = _modalClosers[_i2];
    closer.addEventListener('click', function (event) {
      var modalId = closer.dataset.modalid;
      var modal = document.querySelector("div[data-modalid=\"".concat(modalId, "\"]"));
      modal.classList.toggle('tw-opacity-0');
      setTimeout(function () {
        modal.classList.toggle('tw-hidden');
      }, 300);
    });
  };
  for (var _i2 = 0, _modalClosers = modalClosers; _i2 < _modalClosers.length; _i2++) {
    _loop2();
  }
}, 500);
//

/***/ }),

/***/ "./src/openCartNote.ts":
/*!*****************************!*\
  !*** ./src/openCartNote.ts ***!
  \*****************************/
/***/ (() => {

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
var editionNote = /*#__PURE__*/function (_HTMLElement) {
  function editionNote() {
    var _this;
    _classCallCheck(this, editionNote);
    _this = _callSuper(this, editionNote);
    _this.addEventListener("click", _this.handleClick);
    return _this;
  }
  _inherits(editionNote, _HTMLElement);
  return _createClass(editionNote, [{
    key: "handleClick",
    value: function handleClick(event) {
      var cartNoteElement = document.querySelector("cart-drawer-disclosure");
      var span = cartNoteElement.querySelector("span");
      span.click();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("edition-note", editionNote);

/***/ }),

/***/ "./src/pickandmix.ts":
/*!***************************!*\
  !*** ./src/pickandmix.ts ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _formatmoney__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./formatmoney */ "./src/formatmoney.ts");
/* harmony import */ var _updatecart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./updatecart */ "./src/updatecart.ts");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
// import nessescary types from types.ts

// import the formatMoney function from formatmoney.ts

// import updateCart function from updatecart.ts

// Define the edition-pick-and-mix custom element, which is a wrapper for the pick and mix component on product cards
var editionPickandmix = /*#__PURE__*/function (_HTMLElement) {
  function editionPickandmix() {
    _classCallCheck(this, editionPickandmix);
    return _callSuper(this, editionPickandmix);
  }
  _inherits(editionPickandmix, _HTMLElement);
  return _createClass(editionPickandmix, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      setTimeout(function () {
        var bundleBar = document.getElementById("edition-bundle-bar");
        var bundleBarItemsHolder = bundleBar.querySelector("#edition-bundle-bar-items");
        var addToBundle = _this.querySelector(".add_to_bundle");
        addToBundle.addEventListener("click", function (event) {
          addToBundle.style.display = "none";
          var productData = addToBundle.dataset;
          // create a edition-quanity-picker element unless there already is one with the same id
          if (!document.querySelector("edition-quantity-picker[data-id=\"".concat(productData.id, "\"]"))) {
            var qtyPicker = document.createElement("edition-quantity-picker");
            qtyPicker.style.height = "unset;";
            qtyPicker.setAttribute("data-id", productData.id);
            qtyPicker.setAttribute("data-maxqty", productData.inventqty);
            qtyPicker.innerHTML = "\n            <button data-function=\"down\" class=\"edition-qty-decrease\" tw-text-[24px]>-</button>\n              <span class=\"tw-text-[16px] edition-qty\"></span>\n            <button data-function=\"up\" class=\"edition-qty-increase tw-text-[24px]\">+</button>\n            ";
            // append the element edition-pick-and-mix as the previous sibling of the button
            addToBundle.before(qtyPicker);
            var qtyInput = qtyPicker.querySelector(".edition-qty");
            qtyInput.setAttribute("data-qty", "1");
            var bundleElement = document.createElement("edition-pick-and-mix-element");
            // Set data attributes on the element
            bundleElement.setAttribute("data-id", productData.id);
            bundleElement.setAttribute("data-img", productData.img);
            bundleElement.setAttribute("data-price", productData.price);
            bundleElement.setAttribute("data-inventqty", productData.inventqty);
            bundleElement.setAttribute("data-amountinbundle", "1");
            bundleElement.innerHTML = "\n            <div class=\"edition-bundle-bar-image\">\n              <img src=\"".concat(productData.img, "\" />\n            </div>\n            <edition-quantity-picker data-id=\"").concat(productData.id, "\" data-maxqty=\"").concat(productData.inventqty, "\" style=\"height:unset;\">\n              <button data-function=\"down\" class=\"edition-qty-decrease tw-text-[24px]\">-</button>\n                <span class=\"tw-text-[16px] edition-qty\"></span>\n              <button data-function=\"up\" class=\"edition-qty-increase tw-text-[24px]\">+</button>\n            </edition-quantity-picker>\n            ");
            var input = bundleElement.querySelector(".edition-qty");
            input.setAttribute("data-qty", "1");
            // Append the element to the bundlebaritemsholder
            bundleBarItemsHolder.appendChild(bundleElement);
          }
        });
      }, 0);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("edition-pick-and-mix", editionPickandmix);
// Define the edition-quantity-picker custom element, which is a wrapper for the quantity picker component on product cards
var editionQuantityPicker = /*#__PURE__*/function (_HTMLElement2) {
  function editionQuantityPicker() {
    _classCallCheck(this, editionQuantityPicker);
    return _callSuper(this, editionQuantityPicker);
  }
  _inherits(editionQuantityPicker, _HTMLElement2);
  return _createClass(editionQuantityPicker, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      // add eventlistener for the custom event edition-qtyinput-change
      // the edition-qtyinput-change event is dispatched when the quantity is changed from all the different quantity pickers
      setTimeout(function () {
        var qtyInput = _this2.querySelector(".edition-qty");
        var dataId = _this2.getAttribute("data-id");
        var allQtyInputs = Array.from(document.querySelectorAll("edition-quantity-picker[data-id=\"".concat(dataId, "\"] .edition-qty")));
        setTimeout(function () {
          document.dispatchEvent(new Event("edition-qtyinput-change"));
        }, 0);
        document.addEventListener("edition-qtyinput-change", function (event) {
          var qty = _this2.querySelector(".edition-qty").getAttribute("data-qty");
          qtyInput.innerText = qty;
          // set the data-amountinbundle attribute on the bundle element
          var bundleElement = _this2.closest("edition-pick-and-mix-element");
          if (bundleElement) {
            bundleElement.setAttribute("data-amountinbundle", qty);
          }
          // if the qty is 0, remove the element
          if (qty == "0") {
            // dispatch the custom event edition-remove-from-bundle
            document.dispatchEvent(new Event("edition-remove-from-bundle"));
          }
          calculatePrices();
        });
        // add eventlistener for the increase and decrease buttons and dispatch the custom event edition-qtyinput-change
        var buttons = Array.from(_this2.querySelectorAll("button"));
        var _loop = function _loop() {
          var button = _buttons[_i];
          button.addEventListener("click", function (event) {
            var functionType = button.dataset["function"];
            var qty = qtyInput.getAttribute("data-qty");
            var maxQty = _this2.getAttribute("data-maxqty");
            var qtyVal = Number(qty);
            var maxQtyVal = Number(maxQty);
            var qtyNumber = functionType == "up" ? qtyVal + 1 : qtyVal - 1;
            // check if the qtyNumber is greater than the maxQtyVal. If it is, set the qtyNumber to the maxQtyVal
            if (qtyNumber > maxQtyVal) {
              qtyNumber = maxQtyVal;
            }
            for (var _i2 = 0, _allQtyInputs = allQtyInputs; _i2 < _allQtyInputs.length; _i2++) {
              var _qtyInput = _allQtyInputs[_i2];
              _qtyInput.setAttribute("data-qty", qtyNumber.toString());
            }
            document.dispatchEvent(new Event("edition-qtyinput-change"));
          });
        };
        for (var _i = 0, _buttons = buttons; _i < _buttons.length; _i++) {
          _loop();
        }
      }, 0);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("edition-quantity-picker", editionQuantityPicker);
// Define the edition-pick-and-mix-element custom element, which is a wrapper for each item in the bundle bar
var editionPickandmixElement = /*#__PURE__*/function (_HTMLElement3) {
  function editionPickandmixElement() {
    _classCallCheck(this, editionPickandmixElement);
    return _callSuper(this, editionPickandmixElement);
  }
  _inherits(editionPickandmixElement, _HTMLElement3);
  return _createClass(editionPickandmixElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {}
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("edition-pick-and-mix-element", editionPickandmixElement);
document.addEventListener("edition-remove-from-bundle", function (event) {
  // find all the edition-pick-and-mix who has a button with a data-qty of 0 and remove the tw-opacity-0 class
  var allAddToBundleButtons = Array.from(document.querySelectorAll("edition-pick-and-mix .edition-qty[data-qty=\"0\"]"));
  for (var _i3 = 0, _allAddToBundleButton = allAddToBundleButtons; _i3 < _allAddToBundleButton.length; _i3++) {
    var addToBundleButton = _allAddToBundleButton[_i3];
    var addToBundle = addToBundleButton.closest("edition-pick-and-mix").querySelector(".add_to_bundle");
    addToBundle.classList.remove("tw-opacity-0");
    addToBundle.style.display = "block";
  }
  // find all the edition-pick-and-mix-elements who's children edition-quantity-picker have a qty of 0 and remove them
  var allBundleElements = Array.from(document.querySelectorAll("edition-pick-and-mix-element[data-id]"));
  for (var _i4 = 0, _allBundleElements = allBundleElements; _i4 < _allBundleElements.length; _i4++) {
    var bundleElement = _allBundleElements[_i4];
    var qty = bundleElement.querySelector(".edition-qty").getAttribute("data-qty");
    if (qty == "0") {
      bundleElement.remove();
    }
  }
  // find all the edition-quantity-pickers that have a qty of 0 and remove them
  // the event.target is the document so does not work
  var allQtyPickers = Array.from(document.querySelectorAll("edition-quantity-picker[data-id]"));
  for (var _i5 = 0, _allQtyPickers = allQtyPickers; _i5 < _allQtyPickers.length; _i5++) {
    var qtyPicker = _allQtyPickers[_i5];
    var _qty = qtyPicker.querySelector(".edition-qty").getAttribute("data-qty");
    if (_qty == "0") {
      qtyPicker.remove();
    }
  }
});
function calculatePrices() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
    var bundleBar, totalComparePriceHolder, totalPriceHolder, totalSavingsHolder, allBundleElements, discountLadder, totalComparePrice, totalAmountInBundle, _i6, _allBundleElements2, bundleElement, comparePrice, amountInBundle, compareTotal, highestDiscountAmount, _iterator, _step, discount, totalPriceWithDiscount, totalDiscount, unitCost;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          bundleBar = document.getElementById("edition-bundle-bar");
          totalComparePriceHolder = bundleBar.querySelector("#edition-pick-and-mix-total-compare-price");
          totalPriceHolder = bundleBar.querySelector("#edition-pick-and-mix-total-price");
          totalSavingsHolder = bundleBar.querySelector("#edition-pick-and-mix-saving-amount");
          allBundleElements = Array.from(document.querySelectorAll("edition-pick-and-mix-element"));
          discountLadder = window.discountLadder; // get the price of each bundle element and calcualte the total compare price
          totalComparePrice = 0;
          totalAmountInBundle = 0;
          for (_i6 = 0, _allBundleElements2 = allBundleElements; _i6 < _allBundleElements2.length; _i6++) {
            bundleElement = _allBundleElements2[_i6];
            comparePrice = Number(bundleElement.getAttribute("data-price"));
            amountInBundle = Number(bundleElement.getAttribute("data-amountinbundle"));
            compareTotal = comparePrice * amountInBundle / 100;
            totalComparePrice += compareTotal;
            totalAmountInBundle += amountInBundle;
          }
          // check totalAmountInBundle is greater than a qty in the discount ladder and get the discount percent that matches
          highestDiscountAmount = 0;
          _iterator = _createForOfIteratorHelper(discountLadder);
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              discount = _step.value;
              if (totalAmountInBundle >= discount.quantity && discount.discount > highestDiscountAmount) {
                highestDiscountAmount = discount.discount;
              }
            }
            // apply the discount to the totalComparePrice
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          totalPriceWithDiscount = totalComparePrice - highestDiscountAmount; // calculate the difference between the totalComparePrice and the totalPriceWithDiscount
          totalDiscount = totalComparePrice - totalPriceWithDiscount; // calculate unit cost
          unitCost = totalPriceWithDiscount / totalAmountInBundle; // format the prices using the formatMoney function from formatmoney.ts
          totalComparePriceHolder.textContent = (0,_formatmoney__WEBPACK_IMPORTED_MODULE_1__["default"])(totalComparePrice);
          totalPriceHolder.textContent = (0,_formatmoney__WEBPACK_IMPORTED_MODULE_1__["default"])(totalPriceWithDiscount);
          totalSavingsHolder.textContent = (0,_formatmoney__WEBPACK_IMPORTED_MODULE_1__["default"])(unitCost);
          // if totalAmountInBundle is greater than 0, show the bundle bar
          // if totalAmountInBundle is 0, hide the bundle bar after 700ms
          if (totalAmountInBundle > 0) {
            bundleBar.style.zIndex = "5";
            bundleBar.classList.add("!tw-opacity-100");
            bundleBar.setAttribute("data-amountinbundle", totalAmountInBundle.toString());
          } else {
            bundleBar.classList.remove("!tw-opacity-100");
            bundleBar.removeAttribute("data-amountinbundle");
            setTimeout(function () {
              bundleBar.style.zIndex = "-1";
            }, 700);
          }
        case 1:
          return _context.a(2);
      }
    }, _callee);
  }));
}
function addBundleToCart(bundleData) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee2() {
    var response, data, bar, text, spinner, allQtyPickers, _i7, _allQtyPickers2, qtyPicker, _t;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.p = 0;
          _context2.n = 1;
          return fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(bundleData)
          });
        case 1:
          response = _context2.v;
          if (!response.ok) {
            _context2.n = 3;
            break;
          }
          _context2.n = 2;
          return response.json();
        case 2:
          data = _context2.v;
        case 3:
          if (response.ok) {
            _context2.n = 4;
            break;
          }
          console.log(response);
          throw new Error("Network response was not ok");
        case 4:
          window._conv_q = window._conv_q || [];
          window._conv_q.push(["triggerConversion", "100494738"]);
          _context2.n = 6;
          break;
        case 5:
          _context2.p = 5;
          _t = _context2.v;
          console.log(_t);
        case 6:
          _context2.p = 6;
          // dispatch two custom events to refresh and open the cart drawer (both from the theme itself)
          document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
            bubbles: true
          }));
          document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open", {
            bubbles: true
          }));
          // show text and hide spinner
          bar = document.getElementById("edition-bundle-bar");
          text = bar.querySelector(".edition-btn-text");
          spinner = bar.querySelector(".edition-loader");
          text.classList.remove("!tw-opacity-0");
          spinner.classList.remove("!tw-flex");
          // reset all the bundle picker elements
          allQtyPickers = Array.from(document.querySelectorAll(".edition-qty"));
          for (_i7 = 0, _allQtyPickers2 = allQtyPickers; _i7 < _allQtyPickers2.length; _i7++) {
            qtyPicker = _allQtyPickers2[_i7];
            qtyPicker.setAttribute("data-qty", "0");
          }
          document.dispatchEvent(new Event("edition-qtyinput-change"));
          return _context2.f(6);
        case 7:
          return _context2.a(2);
      }
    }, _callee2, null, [[0, 5, 6, 7]]);
  }));
}
setTimeout(function () {
  var editionBundleBar = document.getElementById("edition-bundle-bar");
  if (editionBundleBar) {
    var addBundleToCartButton = editionBundleBar.querySelector("#edition-pick-and-mix-add-bundle-to-cart");
    addBundleToCartButton.addEventListener("click", function (event) {
      // hide text and show spinner
      var bar = document.getElementById("edition-bundle-bar");
      var text = bar.querySelector(".edition-btn-text");
      var spinner = bar.querySelector(".edition-loader");
      text.classList.add("!tw-opacity-0");
      spinner.classList.add("!tw-flex");
      // get all the bundle elements
      var allBundleElements = Array.from(document.querySelectorAll("edition-pick-and-mix-element"));
      // create the bundleData object
      var bundleData = {
        items: []
      };
      // generate a random bundle id of 6 digits
      var randomNum = crypto.getRandomValues(new Uint32Array(1))[0].toString().substring(0, 6);
      for (var _i8 = 0, _allBundleElements3 = allBundleElements; _i8 < _allBundleElements3.length; _i8++) {
        var bundleElement = _allBundleElements3[_i8];
        var id = bundleElement.getAttribute("data-id");
        var qty = bundleElement.getAttribute("data-amountinbundle");
        var collectionTitle = window.collectionTitle;
        var collectionImg = window.collectionImg;
        var collectionUrl = window.collectionUrl;
        var properties = {
          //generate random bundle id of 6 digits
          MixID: randomNum,
          MixTitle: collectionTitle,
          __MixImg: collectionImg,
          MixCollection: collectionUrl
        };
        var item = {
          id: Number(id),
          quantity: Number(qty),
          properties: properties
        };
        bundleData.items.push(item);
      }
      // add the bundle to the cart
      addBundleToCart(bundleData);
      // delete the localStorage item
      localStorage.removeItem("editionBundleData");
    });
  }
}, 500);
document.addEventListener("click", function (event) {
  // get the drawer
  var drawer = document.getElementById("bundle-drawer");
  var target = event.target;
  if (target.classList.contains("create-bundle-drawer")) {
    // setup the empty drawer
    var drawerItemsHolder = drawer.querySelector("#bundle-drawer-items");
    drawerItemsHolder.innerHTML = "";
    // get the button that was clicked
    var btn = target;
    // the dataset contains the data attributes "imgs", "titles" and "qtys"
    // for each of these itteration create a div
    var titles = btn.dataset.titles.split(",");
    var imgs = btn.dataset.imgs.split(",");
    var qtys = btn.dataset.qtys.split(",");
    var keys = btn.dataset.keys.split(",");
    var variantIds = btn.dataset.variantids.split(",");
    var collectionLink = btn.dataset.collection;
    for (var i = 0; i < titles.length; i++) {
      var element = document.createElement("div");
      element.classList.add("bundle-item-wrapper");
      element.setAttribute("data-key", keys[i]);
      element.setAttribute("data-variantid", variantIds[i]);
      element.setAttribute("data-qty", qtys[i]);
      element.innerHTML = "\n        <div class=\"tw-flex tw-flex-col tw-gap-[5px]\">\n          <div class=\"tw-flex tw-justify-center\">\n            <img src=\"".concat(imgs[i], "\" />\n          </div>\n          <div class=\"tw-flex tw-flex-col tw-items-center\">\n            <p class=\"tw-text-center tw-text-[12px] tw-font-bold\">").concat(titles[i], "</p>\n            <p class=\"tw-text-center tw-text-[12px]\">Antal: ").concat(qtys[i], "</p>\n          </div>\n        </div>\n        ");
      drawerItemsHolder.appendChild(element);
    }
    drawer.classList.toggle("tw-hidden");
    setTimeout(function () {
      drawer.style.transform = "translate(0, 0)";
    }, 100);
    // add eventlistner on the close button
    var closeBtn = drawer.querySelector("#bundle-drawer-close");
    closeBtn.addEventListener("click", function (event) {
      drawer.style.transform = "translate(0, 100%)";
      setTimeout(function () {
        drawer.classList.add("tw-hidden");
      }, 750);
    });
    // add eventlistener on the remake bundle button  + store a cookie with the bundle data + redirect to the bundle page
    var remakeBundle = drawer.querySelector("#bundle-remake");
    remakeBundle.addEventListener("click", function (event) {
      // get all the nessescary data (lineItemKeys) from our bundle-item-wrapper elements and create the updates object
      var allBundleItems = Array.from(drawer.querySelectorAll(".bundle-item-wrapper"));
      // get the variantIds and the quantities and store them as an object in localStorage
      var bundleDataForStorage = {};
      for (var _i9 = 0, _allBundleItems = allBundleItems; _i9 < _allBundleItems.length; _i9++) {
        var bundleItem = _allBundleItems[_i9];
        var variantId = bundleItem.getAttribute("data-variantid");
        var qty = bundleItem.getAttribute("data-qty");
        bundleDataForStorage[variantId] = qty;
      }
      // store the bundleDataForStorage in localStorage
      localStorage.setItem("editionBundleData", JSON.stringify(bundleDataForStorage));
      var updates = {};
      // updates must consistof key-value pairs where the key is the lineItemKey and the value is 0
      for (var _i0 = 0, _allBundleItems2 = allBundleItems; _i0 < _allBundleItems2.length; _i0++) {
        var _bundleItem = _allBundleItems2[_i0];
        var key = _bundleItem.getAttribute("data-key");
        updates[key] = 0;
      }
      (0,_updatecart__WEBPACK_IMPORTED_MODULE_2__["default"])(updates);
      // redirect to the bundle page
      setTimeout(function () {
        window.location.href = collectionLink;
      }, 750);
    });
  }
});
// On dom load, check if there is a cookie with bundle data and if there is, create the bundle
document.addEventListener("DOMContentLoaded", function (event) {
  // get the cookie
  var storedBundle = localStorage.getItem("editionBundleData");
  var bundleDataParsed;
  var keys;
  // if the bundle is stored in localStorage , create the bundle
  if (storedBundle) {
    // get the bundleData and parse it
    bundleDataParsed = JSON.parse(storedBundle);
    // get the key from the bundleDataParsed
    keys = Object.keys(bundleDataParsed);
    console.log(bundleDataParsed);
    console.log(keys);
    setTimeout(function () {
      // for each key find the edition-pick-and-mix element who has a button with the same id and click it
      var _iterator2 = _createForOfIteratorHelper(keys),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;
          var addToBundle = document.querySelector(".add_to_bundle[data-id=\"".concat(key, "\"]"));
          if (addToBundle) {
            addToBundle.click();
            // get the edition-quantity-picker element and set the qty
            var qtyPickers = Array.from(document.querySelectorAll("edition-quantity-picker[data-id=\"".concat(key, "\"]")));
            for (var _i1 = 0, _qtyPickers = qtyPickers; _i1 < _qtyPickers.length; _i1++) {
              var qtyPicker = _qtyPickers[_i1];
              var qtyInput = qtyPicker.querySelector(".edition-qty");
              qtyInput.setAttribute("data-qty", bundleDataParsed[key]);
            }
            document.dispatchEvent(new Event("edition-qtyinput-change"));
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }, 1000);
  }
});
// Theme specific code like moving the bundle bar when specif theme events are fired
// Theme specific code like moving the bundle bar when specif theme events are fired
// Theme specific code like moving the bundle bar when specif theme events are fired
// Theme specific code like moving the bundle bar when specif theme events are fired
// Theme specific code like moving the bundle bar when specif theme events are fired
// Theme specific code like moving the bundle bar when specif theme events are fired
// Theme specific code like moving the bundle bar when specif theme events are fired
setTimeout(function () {
  var bundleBar = document.getElementById("edition-bundle-bar");
  if (bundleBar) {
    // Hide the bundle bar when the cart drawer is opened
    document.addEventListener("dispatch:cart-drawer:open", function (event) {
      bundleBar.style.transition = "transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s";
      bundleBar.style.transform = "translate(-50%, 100%)";
    });
    document.addEventListener("dispatch:cart-drawer:refresh", function (event) {
      // show the bundle bar when the cart drawer is closed
      var overlay = document.querySelector(".overlay.fixed.top-0.right-0.bottom-0.left-0.js-overlay");
      overlay.addEventListener("click", function (event) {
        bundleBar.style.transition = "transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s";
        bundleBar.style.transform = "translate(-50%, -50%)";
      });
      // show the bundle bar when the cart drawer is closed
      document.addEventListener("click", function (event) {
        var target = event.target;
        if (target == document.querySelector(".drawer__close-btn.js-close-drawer")) {
          bundleBar.style.transition = "transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s";
          bundleBar.style.transform = "translate(-50%, -50%)";
        }
      });
      // listen for the keypress escape and show the bundle bar
      document.addEventListener("keydown", function (event) {
        if (event.key == "Escape") {
          bundleBar.style.transition = "transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s";
          bundleBar.style.transform = "translate(-50%, -50%)";
        }
      });
    });
  }
}, 1000);
// add eventlistner on the delete button and delete the bundle / and update the cart
document.addEventListener("click", function (event) {
  var target = event.target;
  if (target.classList.contains("bundle-delete")) {
    var drawer = document.getElementById("bundle-drawer");
    var closestCartDetailsEle = target.closest(".cart-item__details");
    var createBundle = closestCartDetailsEle.querySelector(".create-bundle-drawer");
    createBundle.click();
    // get all the nessescary data (lineItemKeys) from our bundle-item-wrapper elements and create the updates object
    var allBundleItems = Array.from(drawer.querySelectorAll(".bundle-item-wrapper"));
    var updates = {};
    // updates must consistof key-value pairs where the key is the lineItemKey and the value is 0
    for (var _i10 = 0, _allBundleItems3 = allBundleItems; _i10 < _allBundleItems3.length; _i10++) {
      var bundleItem = _allBundleItems3[_i10];
      var key = bundleItem.getAttribute("data-key");
      updates[key] = 0;
    }
    (0,_updatecart__WEBPACK_IMPORTED_MODULE_2__["default"])(updates);
    drawer.style.transform = "translate(0, 100%)";
  }
});

/***/ }),

/***/ "./src/types.ts":
/*!**********************!*\
  !*** ./src/types.ts ***!
  \**********************/
/***/ (() => {



/***/ }),

/***/ "./src/updateCartDelivery.ts":
/*!***********************************!*\
  !*** ./src/updateCartDelivery.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartDelivery)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var CartDelivery = /*#__PURE__*/function (_HTMLElement) {
  function CartDelivery() {
    var _this;
    _classCallCheck(this, CartDelivery);
    _this = _callSuper(this, CartDelivery);
    _this.updateCartDeliveryText = _this.updateCartDeliveryText.bind(_this);
    _this.handleEvent = _this.handleEvent.bind(_this);
    _this.handleCartContentLoaded = _this.handleCartContentLoaded.bind(_this);
    _this.init = _this.init.bind(_this);
    _this.updateLiveTimeCountdown = _this.updateLiveTimeCountdown.bind(_this);
    _this.startCountdown = _this.startCountdown.bind(_this);
    return _this;
  }
  // eslint-disable-next-line class-methods-use-this
  _inherits(CartDelivery, _HTMLElement);
  return _createClass(CartDelivery, [{
    key: "getExpectedDeliveryDates",
    value: function getExpectedDeliveryDates() {
      var today = new Date();
      var dayOfWeek = today.getDay();
      var extraDaysMondayOne = window.extraDaysMondayOne || 0;
      var extraDaysMondayTwo = window.extraDaysMondayTwo || 0;
      var extraDaysTuesdayOne = window.extraDaysTuesdayOne || 0;
      var extraDaysTuesdayTwo = window.extraDaysTuesdayTwo || 0;
      var extraDaysWednesdayOne = window.extraDaysWednesdayOne || 0;
      var extraDaysWednesdayTwo = window.extraDaysWednesdayTwo || 0;
      var extraDaysThursdayOne = window.extraDaysThursdayOne || 0;
      var extraDaysThursdayTwo = window.extraDaysThursdayTwo || 0;
      var extraDaysFridayOne = window.extraDaysFridayOne || 0;
      var extraDaysFridayTwo = window.extraDaysFridayTwo || 0;
      var extraDaysSaturday = window.extraDaysSaturday || 0;
      var extraDaysSunday = window.extraDaysSunday || 0;
      var deliveryDate;
      switch (dayOfWeek) {
        case 1:
          // Monday
          deliveryDate = today.getHours() < 15 ? new Date(today.getTime() + extraDaysMondayOne * 24 * 60 * 60 * 1000) : new Date(today.getTime() + extraDaysMondayTwo * 24 * 60 * 60 * 1000);
          break;
        case 2:
          // Tuesday
          deliveryDate = today.getHours() < 15 ? new Date(today.getTime() + extraDaysTuesdayOne * 24 * 60 * 60 * 1000) : new Date(today.getTime() + extraDaysTuesdayTwo * 24 * 60 * 60 * 1000);
          break;
        case 3:
          // Wednesday
          deliveryDate = today.getHours() < 15 ? new Date(today.getTime() + extraDaysWednesdayOne * 24 * 60 * 60 * 1000) : new Date(today.getTime() + extraDaysWednesdayTwo * 24 * 60 * 60 * 1000);
          break;
        case 4:
          // Thursday
          deliveryDate = today.getHours() < 15 ? new Date(today.getTime() + extraDaysThursdayOne * 24 * 60 * 60 * 1000) : new Date(today.getTime() + extraDaysThursdayTwo * 24 * 60 * 60 * 1000);
          break;
        case 5:
          // Friday
          deliveryDate = today.getHours() < 15 ? new Date(today.getTime() + extraDaysFridayOne * 24 * 60 * 60 * 1000) : new Date(today.getTime() + extraDaysFridayTwo * 24 * 60 * 60 * 1000);
          break;
        case 6:
          // Saturday
          deliveryDate = new Date(today.getTime() + extraDaysSaturday * 24 * 60 * 60 * 1000);
          break;
        case 0:
          // Sunday
          deliveryDate = new Date(today.getTime() + extraDaysSunday * 24 * 60 * 60 * 1000);
          break;
        default:
          throw new Error('Invalid day of the week');
      }
      var storeLangSetting = window.storeLang || 'da';
      var options = {
        day: 'numeric',
        month: 'long'
      };
      var deliveryStr = deliveryDate.toLocaleDateString(storeLangSetting, options);
      return deliveryStr;
    }
  }, {
    key: "updateCartDeliveryText",
    value: function updateCartDeliveryText() {
      var _this2 = this;
      var cartdeliveryTextElements = document.querySelectorAll('.cart-estimated-delivery-text');
      cartdeliveryTextElements.forEach(function (element) {
        element.innerText = "".concat(_this2.getExpectedDeliveryDates());
      });
    }
  }, {
    key: "startCountdown",
    value: function startCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      this.updateLiveTimeCountdown();
      this.countdownTimer = window.setInterval(this.updateLiveTimeCountdown, 1000);
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "updateLiveTimeCountdown",
    value: function updateLiveTimeCountdown() {
      var liveTimeElement = document.querySelector('.liveTime');
      var liveTimeContainer = document.querySelector('.liveTimeContainer');
      if (!liveTimeElement) return;
      var now = new Date();
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
      var threePm = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 15, 0, 0);
      // If it's before midnight or at/after 15:00 => hide the timer
      if (now < midnight || now >= threePm) {
        liveTimeContainer.style.display = 'none';
        return;
      }
      liveTimeContainer.style.display = 'block';
      var distance = threePm.getTime() - now.getTime();
      var hours = Math.floor(distance / (1000 * 60 * 60));
      var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      var seconds = Math.floor(distance % (1000 * 60) / 1000);
      var hh = hours.toString().padStart(2, '0');
      var mm = minutes.toString().padStart(2, '0');
      var ss = seconds.toString().padStart(2, '0');
      liveTimeElement.innerText = "".concat(hh, ":").concat(mm, ":").concat(ss);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;
      this.observer = new MutationObserver(function () {
        var cartdeliveryTextElements = document.querySelectorAll('.cart-estimated-delivery-text');
        if (cartdeliveryTextElements.length > 0) {
          _this3.updateCartDeliveryText();
          _this3.observer.disconnect();
        }
      });
      this.init();
      // Start the countdown to 15:00 (it will hide itself if outside 00:00–15:00)
      this.startCountdown();
    }
  }, {
    key: "init",
    value: function init() {
      this.observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      /*
        If you want to handle certain Shopify (or custom) events, re-add them here.
        For example:
          document.addEventListener('line-item:change:start', this.handleEvent);
          document.addEventListener('line-item:change:end', this.handleEvent);
          document.addEventListener('cart:item-added', this.handleEvent);
          document.addEventListener('product:variant-change', this.handleEvent);
          document.addEventListener('DOMContentLoaded', this.handleEvent);
      */
      this.handleCartContentLoaded();
      this.interceptNetRequest();
    }
  }, {
    key: "interceptNetRequest",
    value: function interceptNetRequest() {
      var originalFetch = window.fetch.bind(window);
      function fetch(url, options) {
        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (typeof url === 'string' && (url.includes('cart/add') || url.includes('cart/change'))) {
                  this.handleEvent();
                }
                return _context.a(2, originalFetch(url, options));
            }
          }, _callee, this);
        }));
      }
      window.fetch = fetch.bind(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent() {
      var cartdeliveryTextElements = document.querySelectorAll('.cart-estimated-delivery-text');
      if (cartdeliveryTextElements.length > 0) {
        this.updateCartDeliveryText();
      } else {
        this.observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }
  }, {
    key: "handleCartContentLoaded",
    value: function handleCartContentLoaded() {
      var cartdeliveryTextElements = document.querySelectorAll('.cart-estimated-delivery-text');
      if (cartdeliveryTextElements.length > 0) {
        this.updateCartDeliveryText();
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      document.removeEventListener('DOMContentLoaded', this.handleCartContentLoaded);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/updatecart.ts":
/*!***************************!*\
  !*** ./src/updatecart.ts ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_0__);
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
// Import the updates-type from types.ts

// function to update the cart using shopify cart/update.js endpoint
// the function takes in an updates object that contains key-value pairs where the key is a lineitemkey and the value is the desired quantity
function updateCart(updates) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
    var response, data, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              updates: updates
            })
          });
        case 1:
          response = _context.v;
          _context.n = 2;
          return response.json();
        case 2:
          data = _context.v;
          if (response.ok) {
            // dispatch an event to update the cart
            document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
              bubbles: true
            }));
            console.log("cart updated");
          }
          if (!response.ok) {
            console.log(response);
          }
          _context.n = 4;
          break;
        case 3:
          _context.p = 3;
          _t = _context.v;
          console.error(_t);
        case 4:
          _context.p = 4;
          return _context.f(4);
        case 5:
          return _context.a(2);
      }
    }, _callee, null, [[0, 3, 4, 5]]);
  }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (updateCart);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/app": 0,
/******/ 			"assets/app": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkpurepower_multistore"] = self["webpackChunkpurepower_multistore"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/BiscuitsBundleEvents.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/CartProgressSection.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/consent.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/formatmoney.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/freeGift.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/freeshippingbar.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/klaviyoAddedToCart.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/mixpdp.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/modalopener.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/openCartNote.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/pickandmix.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/types.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/updatecart.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/updateCartDelivery.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;